import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import FeedbackForm from './FeedbackForm';
import { useTranslation } from 'react-i18next';

const FeedbackDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onClose();
    toast.success(t('feedback.thanks'));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up' }}
      PaperProps={{
        sx: {
          borderRadius: { xs: '16px 16px 0 0', sm: 2 },
          position: { xs: 'fixed', sm: 'relative' },
          bottom: { xs: 0, sm: 'auto' },
          m: { xs: 0, sm: 2 },
          width: { xs: '100%', sm: undefined },
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {t('feedback.thanks')}
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FeedbackForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackDialog;
